import { CheckCircle2, Users, FileText } from "lucide-react";
import { useBrand } from "@/brand";

const cards = [
  {
    icon: CheckCircle2,
    title: "Enkelt og oversiktlig",
    text: "Fakturaer du forstår, klare vilkår og full kontroll over bedriftens energikostnader. Ingen bindingstider med urimelige vilkår.",
  },
  {
    icon: Users,
    title: "Kunden først",
    text: "Direkte rådgivning fra dedikerte energirådgivere som kjenner norsk kraftmarked og forstår næringslivets behov.",
  },
  {
    icon: FileText,
    title: "Åpenhet og tillit",
    text: "Fullstendig transparens i alle ledd. Du ser nøyaktig hva kraften koster på børsen og hva som er vårt transparente påslag.",
  },
];

const WhySection = () => {
  const brand = useBrand();
  return (
  <section id="hvorfor" className="py-24 bg-white border-b border-slate-200" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="max-w-2xl mb-16">
        <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">
          Fordeler for bedriften
        </span>
        <h2 className="font-serif-heading text-3xl sm:text-4xl font-bold text-[#0B132B] mt-2 tracking-tight">
          Hvorfor velge {brand.name}
        </h2>
        <p className="text-slate-600 mt-4 leading-relaxed">
          Vi leverer utelukkende til bedriftsmarkedet. Ingen skjulte gebyrer,
          ingen uoversiktlige avtaler – kun målrettet energiforvaltning som
          beskytter driftsmarginene deres.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {cards.map((card) => (
          <div
            key={card.title}
            className="p-8 rounded-xl bg-slate-50 border border-slate-200 hover:border-emerald-500/40 transition-colors"
            data-testid={`why-card-${card.title.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="w-12 h-12 rounded-lg bg-emerald-100 border border-emerald-200 flex items-center justify-center text-emerald-700 mb-6">
              <card.icon className="w-6 h-6" aria-hidden="true" />
            </div>
            <h3 className="text-xl font-bold text-[#0B132B] mb-3">{card.title}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{card.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default WhySection;
